import React from 'react';

class Divider extends React.Component {

    constructor(props) {
        super(props);
        this.dividerStyle = {
            minHeight: props.height ?? 0,
            minWidth: props.width ?? 0,
            backgroundColor: props.color
        };
    }

    render() {
        return <div style={this.dividerStyle}/>;
    }
}

export default Divider;